import {
  OPENING_BAR_THICKNESS_PX,
  openingBarColor
} from 'utils/opening-visuals';
import {
  PolygonWallOpeningDrawnType,
  PolygonWallOpeningSpanType
} from 'utils/space-polygon-wall-opening-types';

export function getPolygonWallOpeningDrawn(
  opening: PolygonWallOpeningSpanType
): PolygonWallOpeningDrawnType {
  return {
    id: opening.id,
    type: opening.type,
    bar: {
      p1: opening.p1,
      p2: opening.p2,
      color: openingBarColor(opening.type),
      strokeWidth: OPENING_BAR_THICKNESS_PX
    }
  };
}
